import { render } from "./CodePrepa.vue?vue&type=template&id=0fdada25&scoped=true"
import script from "./CodePrepa.vue?vue&type=script&lang=js"
export * from "./CodePrepa.vue?vue&type=script&lang=js"

import "./CodePrepa.vue?vue&type=style&index=0&id=0fdada25&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fdada25"]])

export default __exports__